// extracted by mini-css-extract-plugin
export var readonly = "_eq-1";
export var star = "_eq-0";